function dig(object, property) {
	let props = property.split('.');
	let value = object;

	for (let prop of props)
		value = value[prop];

	return value;
}

export function unionState(oldArray, newArray, oldField = 'id', newField = 'id') {
	const newIds = newArray.map(newItem => dig(newItem, newField));
	const oldIds = oldArray.map(oldItem => dig(oldItem, oldField));
	const result = [];

	for (let oldItem of oldArray) {
		const index = newIds.indexOf(dig(oldItem, oldField));

		// If old item does not exist in new payload, just add it to result
		if (index === -1)
			result.push(oldItem);

		// Otherwise, use new version of the item
		else
			result.push(newArray.find(item => dig(item, newField) === dig(oldItem, oldField)));
	}
	
	// Now for new items that totally do not exist in the old array, append them to the end 
	return [
		...result,
		...newArray.filter(newItem => oldIds.indexOf(dig(newItem, newField)) === -1)
	];
}